import React from 'react';
import {
  Container,
  Flex,
  Heading,
  useColorModeValue,
  Text,
  Center,
  useMediaQuery,
  Image,
} from '@chakra-ui/react';
import LoginForm from '../../../components/forms/LoginForm';
import { useAuth } from '../../../providers/auth';
import Loader from '../../../components/Loader';

import logo from '../../../assets/images/logo_black.png';
import background from '../../../assets/images/fundo-login.png';

export function LoginPage() {
  const { loading } = useAuth();
  const [isSmallerThan1280] = useMediaQuery('(max-width: 767px)');

  if (loading) {
    return <Loader />;
  }

  return (
    <Flex
      direction={['column', 'row']}
      h="full"
      minH="100vh"
      bg={useColorModeValue('theme.light.body', 'theme.dark.body')}
    >
      {!isSmallerThan1280 && (
        <Flex w="full" minH="100vh" align="center" justify="center">
          <Flex align="center" justify="center">
            <Image maxH="300px" src={logo} />
          </Flex>
        </Flex>
      )}
      <Center
        w="full"
        minH="100vh"
        backgroundImage={background}
        backgroundSize="cover"
        bgRepeat="no-repeat"
        backgroundPosition="bottom center"
        backdropFilter="blur(8px)"
        borderBottomLeftRadius={15}
        borderTopLeftRadius={15}
        justifyContent="center"
      >
        <Container maxW="400px">
          <Heading fontSize={33} color="#FFFFFF" mb="6px">
            Entrar
          </Heading>
          <Text fontSize={20} color="#FFFFFF" mb="40px">
            Digite suas informações para acessar
          </Text>
          <LoginForm />
        </Container>
      </Center>
    </Flex>
  );
}
